// 字典类型多选,返回名称
export const codesToNames = (codes, dictObj) => {
    const names = [];
    const codesArr = codes ? codes.split(',') : [];
    if (codesArr && codesArr.length) {
        codesArr.forEach((key) => {
            if (dictObj && dictObj[key]) {
                names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
            }
        });
    }
    return names.join(',');
}